import React, { useEffect, useState } from "react";
import axios from "axios";
import { getSession } from "../utils/session";
import "./Videoteca.css";
import { API_URL, ORIGEN_API } from "../services/api";

const RUTINA = "Tu rutina";
const TODOS = "Todos";

export default function Videoteca() {
  const [videos, setVideos] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const [filtro, setFiltro] = useState(RUTINA);
  const [abierto, setAbierto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  // Cargar userId desde Capacitor Storage
  useEffect(() => {
    async function fetchUser() {
      const { user } = await getSession();
      setUserId(user?._id || user?.id || null);
    }
    fetchUser();
  }, []);

  useEffect(() => {
    const fetchVideos = async () => {
      setLoading(true);
      setError("");
      try {
        const [rutina, todos] = await Promise.all([
          axios.post(`${API_URL}/videolibrary/generate`, { userId }),
          axios.get(`${API_URL}/videolibrary/catalogo`)
        ]);
        setVideos(rutina.data.videos || []);
        setCatalogo(todos.data || []);
      } catch (err) {
        setError("No se pudo cargar la videoteca.");
      } finally {
        setLoading(false);
      }
    };
    if (userId) fetchVideos();
  }, [userId]);

  // Escape cierra el ejercicio ampliado
  useEffect(() => {
    if (!abierto) return;
    const alPulsar = (e) => e.key === "Escape" && setAbierto(null);
    window.addEventListener("keydown", alPulsar);
    return () => window.removeEventListener("keydown", alPulsar);
  }, [abierto]);

  const grupos = [RUTINA, TODOS, ...[...new Set(catalogo.map((e) => e.tipo))].sort((a, b) => a.localeCompare(b, "es"))];
  const visibles =
    filtro === RUTINA ? videos
    : filtro === TODOS ? catalogo
    : catalogo.filter((e) => e.tipo === filtro);

  return (
    <div className="videoteca-main">
      <p className="app-sub videoteca-sub">
        La técnica de cada ejercicio. Toca uno para verlo en grande.
      </p>

      {catalogo.length > 0 && (
        <div className="videoteca-filtros" role="group" aria-label="Grupo muscular">
          {grupos.map((g) => (
            <button
              key={g}
              className={"videoteca-filtro" + (filtro === g ? " is-active" : "")}
              aria-pressed={filtro === g}
              onClick={() => setFiltro(g)}
            >
              {g}
            </button>
          ))}
        </div>
      )}

      {loading && <div className="app-estado">Preparando tu videoteca...</div>}
      {error && <div className="app-estado app-estado-error">{error}</div>}
      <section className="videoteca-grid">
        {visibles.map((video, idx) => (
          <button
            key={video.url || idx}
            className="videoteca-card"
            style={{ "--d": `${Math.min(idx, 12) * 40}ms` }}
            onClick={() => setAbierto(video)}
            disabled={!video.url}
          >
            {video.url ? (
              <div className="videoteca-iframe-wrapper">
                <img
                  className="videoteca-iframe"
                  src={ORIGEN_API + video.url}
                  alt=""
                  loading="lazy"
                />
              </div>
            ) : (
              <div className="videoteca-pendiente">
                <span className="videoteca-play" aria-hidden="true" />
                Vídeo pendiente
              </div>
            )}
            <div className="videoteca-card-cuerpo">
              <div className="videoteca-card-title">{video.title}</div>
              <div className="videoteca-card-footer">{video.detalle || video.tipo}</div>
            </div>
          </button>
        ))}
      </section>
      {!loading && visibles.length === 0 && !error && (
        <div className="app-estado">No hay vídeos para mostrar aún.</div>
      )}
      {/* Obligatorio por los términos de las animaciones (ver Backend/videos/README.md) */}
      <p className="videoteca-credito">
        Animaciones © <a href="https://gymvisual.com/" target="_blank" rel="noreferrer">Gym visual</a>
      </p>

      {abierto && (
        <div className="popup-overlay" onClick={() => setAbierto(null)}>
          <div
            className="popup videoteca-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="videoteca-modal-titulo"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-button" onClick={() => setAbierto(null)} aria-label="Cerrar" autoFocus>
              ✖
            </button>
            <h2 id="videoteca-modal-titulo">{abierto.title}</h2>
            <div className="videoteca-modal-cuerpo">
              <img
                className="videoteca-modal-gif"
                src={ORIGEN_API + abierto.url}
                alt={`Técnica: ${abierto.title}`}
              />
              <div>
                {abierto.detalle && <p className="videoteca-card-footer">{abierto.detalle}</p>}
                {abierto.instrucciones?.length > 0 && (
                  <ol className="videoteca-pasos">
                    {abierto.instrucciones.map((paso, i) => <li key={i}>{paso}</li>)}
                  </ol>
                )}
              </div>
            </div>
            <p className="videoteca-credito">© Gym visual — gymvisual.com</p>
          </div>
        </div>
      )}
    </div>
  );
}
